import { InjectionToken } from '@angular/core';

/**
 * Shared SSR tokens for server-side rendering context.
 * Use these tokens to inject the request and response objects in Angular Universal/Nx SSR setups.
 */
export const REQUEST = new InjectionToken<unknown>('REQUEST');
export const RESPONSE = new InjectionToken<unknown>('RESPONSE');
export const SSR_REQUEST = new InjectionToken<Request>('SSR_REQUEST');
export const SSR_RESPONSE = new InjectionToken<Response>('SSR_RESPONSE');
